import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import GoogleButton from "@/components/GoogleButton";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Accedi" subtitle="Bentornato su FYDATE">
      <GoogleButton label="Accedi con Google" />
      <div className="flex items-center gap-3 my-4">
        <div className="h-px flex-1 bg-[#DADFEA]" />
        <span className="text-xs text-[#4A4E68]">oppure</span>
        <div className="h-px flex-1 bg-[#DADFEA]" />
      </div>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" />
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1" />
        </div>
        {error && <p data-testid="login-error" className="text-sm text-[#C0392B]">{error}</p>}
        <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full h-12 bg-[#FFD23F] hover:bg-[#F2C200] text-[#0F1230] text-base rounded-full">
          {loading ? "Accesso..." : "Accedi"}
        </Button>
        <div className="flex justify-between text-sm">
          <Link to="/forgot-password" data-testid="forgot-link" className="text-[#141A3A]">Password dimenticata?</Link>
          <Link to="/register" data-testid="to-register-link" className="text-[#141A3A] font-medium">Registrati</Link>
        </div>
      </form>
    </AuthShell>
  );
}
